import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/home-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/hero-section.tsx");
